<script>
  import Contained from '../components/button-contained.svelte'


  import {
    createEventDispatcher
  } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<div class="overlay">
  <div class="card modal">
    <h6>Welcome to Raft!</h6>
    <p>Thank you for trying our new audio experiment.</p>
    <p class="invert" style="background-color: #E71D36; text-align: center; padding: 5px;"><strong>CAUTION!</strong> This show goes near/across roads, always pay attention to your surroundings when near roads.</p>
    <h6>How to play:</h6>
    <p>- Raft will lead you on a walk around Buxton.</p>
    <p>- A number of audio scenes will play automatically as you walk from place to place.</p>
    <p>- Occasionally the map will update with directions to the next location.</p>
    <p>- Simply follow the map and the story will be revealed to you as you go!</p>
    <h6>Encountered a Problem?</h6>
    <p>Go to the Settings menu on the top right, and follow the 'Report a Bug' link.</p>
    <Contained ref="next" on:pressed="{(e) => dispatch('next', e.detail.ref)}" text=Start />
</div>
</div>

<style>
  .modal {
    width: 70vw;
    max-height: 70vh;
    overflow: scroll;
    margin: 80px 10vw;
  }

  h6 {
    margin: 0 0 15px 0;
  }

  .overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1500;
  }
</style>
